import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { createI18n, type I18n } from 'vue-i18n';

export const DEFAULT_LANGUAGE = HgSupportedLanguage.DE;

export enum LocaleFileSuffix {
  HG = 'hg',
  IS24 = 'is24',
}

let localeSuffix = LocaleFileSuffix.HG;

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  silentFallbackWarn: true,
  missing: (currentLocale, key) =>
    console.warn(`Missing translations for "${key}" in "${currentLocale}"`),
  messages: {},
});

export function initI18n(
  translations: any = {},
  fileSuffix = LocaleFileSuffix.HG,
  locale = DEFAULT_LANGUAGE,
): I18n {
  localeSuffix = fileSuffix;
  i18n.global.mergeLocaleMessage(locale, { ...translations });

  return i18n;
}

export async function safeLoadTranslations(locale: HgSupportedLanguage): Promise<void> {
  try {
    await loadTranslations(locale);
  } catch (err) {
    console.error('Could not load locales', err);
  }
}

async function loadTranslations(locale: HgSupportedLanguage): Promise<void> {
  // eslint-disable-next-line import/dynamic-import-chunkname
  const localeLoaded = await import(`@/i18n/${locale}-${localeSuffix}.ts`);
  i18n.global.mergeLocaleMessage(locale, { ...localeLoaded.default });
}

export async function setLocaleBeforeRouteChange(locale: HgSupportedLanguage): Promise<void> {
  if (!(locale in i18n.global.messages)) {
    await safeLoadTranslations(locale);
  }
}
